module.exports = __webpack_public_path__ + "img/img_17_brand_retail@3x.57c1a85d.png";